import { IOffer } from '../../offer';
import { TThunkAction, TThunkDispatch } from '../../types/redux';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EChatActionTypes {
  Open = 'Chat/Open',
  Close = 'Chat/Close',
}

export type TOpenChat = ITypedReduxAction<EChatActionTypes.Open, IOffer>;
export type TCloseChat = ITypedReduxAction<EChatActionTypes.Close>;

/**
 * Action открытия чата
 * @param IOffer
 */
export const openChat: (payload: IOffer) => TOpenChat = actionGenerator<EChatActionTypes.Open, IOffer>(
  EChatActionTypes.Open,
);

/**
 * Callback авторизации при попытке открыть чаты
 * @param IOffer
 */
export const onChatSuccessAuth = (offer: IOffer) => (): TThunkAction => (dispatch: TThunkDispatch) =>
  dispatch(openChat(offer));

/**
 * Action закрытия чата
 */
export const closeChat: () => TCloseChat = actionGenerator<EChatActionTypes.Close>(EChatActionTypes.Close);

export type TChatActions = TOpenChat | TCloseChat;
